module.exports = __webpack_public_path__ + "img/lx2.72ac325a.png";